<template>
  <div id="content" tabindex="-1" class="o-wrapper">
    <div class="o-wrapper o-wrapper--text">
      <div class="c-hero">
        <h1 class="c-hero__title">{{ data.title }}</h1>
      </div>
    </div>
    <div class="o-grid__item u-size-12 u-size-8@desktop u-align-center">
      <article class="c-article">
        <div class="c-article__content">
          <div v-html="data.intro" />
          <div class="fsSection fs3Col" id="fsSection72218219">
            <div class="fsSectionHeader"></div>

            <form @submit.prevent="onSubmit" novalidate>
              <div class="fsRow">
                <div class="fsRowBody fsCell fsFieldCell">
                  <label class="fsLabel">
                    Gemeente
                    <span class="fsRequiredMarker">*</span>
                  </label>
                  <vue-select
                    label="name"
                    v-model="group"
                    :options="groups"
                    required
                    id="input-1"
                    :class="{'hasError': $v.group.$error}"
                  >
                    <template #search="{attributes, events}">
                      <input
                        class="vs__search fsRequired"
                        :required="!group"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </vue-select>
                  <div class="error" v-if="$v.group.$error">Kies je gemeente</div>
                </div>
              </div>
              <div class="fsRow">
                  <div class="fsRowBody fsCell fsFieldCell">
                      <label class="fsLabel">
                          Naam <span class="fsRequiredMarker">*</span>
                      </label>
                      <b-input
                              type="text"
                              id="input-2"
                              v-model="name"
                              :class="{'hasError': $v.name.$error}"
                              required
                      />
                      <div class="error" v-if="$v.name.$error && !$v.name.required">Naam is verplicht</div>
                  </div>
              </div>
              <div class="fsRow">
                <div class="fsRowBody fsCell fsFieldCell">
                  <label class="fsLabel">
                    E-mailadres
                    <span class="fsRequiredMarker">*</span>
                  </label>

                  <b-input
                    type="email"
                    id="input-2"
                    v-model="email"
                    :class="{'hasError': $v.email.$error}"
                    required
                  />
                  <div class="error" v-if="$v.email.$error && !$v.email.required">Email is verplicht</div>
                  <div class="error" v-if="$v.email.$error && !$v.email.email">Email is niet correct</div>

                </div>
              </div>
              <button type="submit">Start de quickscan</button>
            </form>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import VueSelect from "vue-select";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "Home",
  components: {
    VueSelect
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.$router.push({ name: "Questions" });
      }
    }
  },
  data() {
    return {
      submitStatus: "NOPE",
    };
  },
  validations: {
    group: {
      required
    },
    name: {
      required
    },
    email: {
      required,
      email
    }
  },
  computed: {
    data: {
      get() {
        return this.$store.state.data;
      },
      set(newValue) {
        return this.$store.dispatch("setData", newValue);
      }
    },
    email: {
      get() {
        return this.$store.state.email;
      },
      set(newValue) {
        return this.$store.dispatch("setEmail", newValue);
      }
    },
    name: {
      get() {
          return this.$store.state.name;
      },
      set(newValue) {
          return this.$store.dispatch("setName", newValue);
      }
    },
    newsletter: {
      get() {
        return this.$store.state.newsletter;
      },
      set(newValue) {
        return this.$store.dispatch("setNewsletter", newValue);
      }
    },
    group: {
      get() {
        return this.$store.state.group;
      },
      set(newValue) {
        return this.$store.dispatch("setGroup", newValue);
      }
    },
    groups() {
      return this.$store.state.congregations;
    }
  }
};
</script>
<style lang="scss">
button.vs__clear {
  color: #000 !important;
  background: none !important;
}

.v-select {
  background-color: #f7f6f4;
  border-radius: 4px;
  .vs__dropdown-toggle {
    border: none;
    input {
      padding: 0;
      &:focus {
        border: none;
      }
    }
  }
}

ul li::before {
  content: "" !important;
}
.vs__search {
  padding: 0;
}

#input-2 {
  width: 100%;
}

.error {
  color: #f00;
  font-size: 12px;
}
.hasError {
  border: 1px solid #f00 !important;
}
</style>